var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-container mb-eseal-wrap" },
    [
      !_vm.isChoosed
        ? _c("div", { staticClass: "seal", on: { click: _vm.chooseSeal } }, [
            _c("span", { staticClass: "sealIcon" }, [_vm._v("+")]),
            _vm._v(" "),
            _c("span", [_vm._v("添加印章")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isChoosed
        ? _c(
            "div",
            {
              staticClass: "seal_choosed",
              style: {
                left: _vm.posX ? _vm.posX + "px" : 0,
                top: _vm.posY ? _vm.posY + "px" : 0,
              },
              on: { click: _vm.chooseSeal },
            },
            [
              _c("img", {
                staticClass: "sealImg",
                attrs: {
                  src: _vm.choosedSeal.downloadUrl
                    ? _vm.choosedSeal.downloadUrl
                    : _vm.choosedSeal.sealBase64,
                  alt: "",
                },
                on: { touchmove: _vm.onmove },
              }),
              _vm._v(" "),
              _vm.canDelete
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDelete,
                          expression: "showDelete",
                        },
                      ],
                      staticClass: "sealDeleteButton",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.deleteSeal.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n      删除\n    ")]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowModal
        ? _c("div", {
            staticClass: "modal",
            on: {
              mousewheel: function ($event) {
                $event.preventDefault()
              },
              click: function ($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.changeModal.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mb-pop",
          style: { height: _vm.isShowModal ? "318px" : "0" },
        },
        [
          _c("div", { staticClass: "mb-pop_header" }, [
            _c(
              "span",
              {
                staticClass: "seal-type",
                class: _vm.type === "person" ? "is-active" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeType("person")
                  },
                },
              },
              [_vm._v("个人章")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "seal-comp",
                class: _vm.type === "comp" ? "is-active" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeType("comp")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.choosedComp.departmentName))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "go-icon", on: { click: _vm.goChoose } }),
          ]),
          _vm._v(" "),
          _vm.type === "person"
            ? _c("div", { ref: "box", staticClass: "mb-pop_body" }, [
                _c("div", { staticClass: "flex-item" }, [
                  _c(
                    "div",
                    { staticClass: "hand", on: { click: _vm.showHand } },
                    [
                      _c("div", { staticClass: "add" }, [_vm._v("+")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "sign-text" }, [
                        _vm._v("手绘签名"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "hand-signature-wrap" },
                  _vm._l(_vm.handSealList, function (item, index) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.sealBase64,
                            expression: "item.sealBase64",
                          },
                        ],
                        key: index,
                        staticClass: "flex-item",
                      },
                      [
                        _c("img", {
                          attrs: { src: item.sealBase64, alt: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clickSeal(item)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "personal-seal-wrap" },
                  _vm._l(_vm.personalSealList, function (item, index) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.downloadUrl,
                            expression: "item.downloadUrl",
                          },
                        ],
                        key: index,
                        staticClass: "flex-item",
                      },
                      [
                        _c("img", {
                          attrs: { src: item.downloadUrl, alt: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clickSeal(item)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "comp"
            ? _c(
                "div",
                { ref: "box", staticClass: "mb-pop_body" },
                _vm._l(_vm.comSealList, function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.downloadUrl,
                          expression: "item.downloadUrl",
                        },
                      ],
                      key: index,
                      staticClass: "flex-item",
                    },
                    [
                      _c("img", {
                        attrs: { src: item.downloadUrl, alt: "" },
                        on: {
                          click: function ($event) {
                            return _vm.clickSeal(item)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isChooseComp
        ? _c("div", { staticClass: "mb-seal_choose" }, [
            _c("div", { staticClass: "comp-bg" }, [
              _c("div", { staticClass: "choose-header" }, [
                _c(
                  "div",
                  { staticClass: "choose-cancel", on: { click: _vm.onCancle } },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "choose-title" }, [
                  _vm._v("请选择企业"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "choose-cancel" }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-seal_body" },
                _vm._l(_vm.compList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "seal-item",
                      on: {
                        click: function ($event) {
                          return _vm.chooseComp(item)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.departmentName) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCheck
        ? _c("div", { staticClass: "seal-dialog" }, [
            _c("div", { staticClass: "top" }, [
              _c("span", { staticClass: "title" }, [_vm._v("电子签章")]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "closeIcon", on: { click: _vm.closeCheck } },
                [_vm._v("x")]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "check" }, [
              _vm.checkForm.length == 0 && _vm.checkInfo.isSuccess
                ? _c("div", [
                    _c("div", { staticClass: "check-icon_succ" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "check-text" }, [
                      _vm._v("\n          验签成功\n        "),
                    ]),
                  ])
                : _c("div", [
                    _c("div", { staticClass: "check-icon" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "check-text" }, [
                      _vm._v("\n          验签失败\n        "),
                    ]),
                  ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tab" }, [
              _c(
                "div",
                {
                  staticClass: "tab-head",
                  class: _vm.showInfo ? "tab-head_active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.changeTab(true)
                    },
                  },
                },
                [_vm._v("\n        验签信息\n      ")]
              ),
              _vm._v(" "),
              _vm.checkForm.length != 0 || !_vm.checkInfo.isSuccess
                ? _c(
                    "div",
                    {
                      staticClass: "tab-head",
                      class: _vm.showInfo ? "" : "tab-head_active",
                      on: {
                        click: function ($event) {
                          return _vm.changeTab(false)
                        },
                      },
                    },
                    [_vm._v("\n        篡改信息\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showInfo,
                      expression: "showInfo",
                    },
                  ],
                  staticClass: "tab-body",
                },
                _vm._l(_vm.checkInfo.baseInfo, function (val, key) {
                  return _c("div", { key: key, staticClass: "clearfix" }, [
                    _c("label", { staticClass: "kg-label" }, [
                      _vm._v(_vm._s(_vm.infoMap[key]) + ":"),
                    ]),
                    _c("span", { staticClass: "kg-value" }, [
                      _vm._v(_vm._s(val)),
                    ]),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showInfo,
                      expression: "!showInfo",
                    },
                  ],
                  staticClass: "tab-body",
                },
                [
                  _c("div", { staticClass: "info-item" }, [
                    _vm._v(_vm._s(_vm.checkInfo.message)),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.checkForm, function (item, index) {
                    return _c("div", { key: index, staticClass: "info-item" }, [
                      _c("div", [
                        _vm._v(
                          _vm._s(item.protectName) + "由:" + _vm._s(item.origin)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "biangen" }, [
                        _vm._v("变更为:" + _vm._s(item.change)),
                      ]),
                    ])
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              _c("button", { on: { click: _vm.closeCheck } }, [_vm._v("关闭")]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("purpose-mb", {
        attrs: { show: _vm.isShowPurpose },
        on: { "check-succ": _vm.checkSucc },
      }),
      _vm._v(" "),
      _vm.isShowHandWrite
        ? _c("hand", { on: { "hand-write": _vm.getBase64 } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }